module.exports = __webpack_public_path__ + "static/Family Mission1-eecf7874d2b920bc6e3dbe8019440f9d.svg";